import { createFragment } from "@applant/fragment-scripts/fragment";
import {initializeCallButton} from "./components/callbutton";

export * from './components/header';
export * from "./components/logo";
export * from "./components/callbutton";

const { init } = createFragment((rootElement: HTMLElement): Promise<void> => {
    initializeCallButton(rootElement);
    return Promise.resolve();
});

export { init };